export default "__VITE_ASSET__BQvdZtFr__"